class Heap {
    constructor() {
        this.heap = window['heap'] || (window['heap'] = []);
    }

    identify(email) {
        return new Promise(async(resolve, reject) => {
            try {
                await this.heap.identify(email.toLowerCase());

                resolve();
            } catch (error) {
                reject(error);
            }
        })
    }

    getIdentity() {
        try {
            return this.heap.identity
        } catch (error) {
            return 'Unknown Heap identity'
        }
    }

    addUserProperties(properties) {
        return new Promise(async(resolve, reject) => {
            try {
                await this.heap.addUserProperties(properties);

                resolve();
            } catch (error) {
                reject(error);
            }
        })
    }

    addEventProperties(properties) {
        return new Promise(async(resolve, reject) => {
            try {
                await this.heap.addEventProperties(properties);

                resolve();
            } catch (error) {
                reject(error);
            }
        })
    }
}

export default new Heap()
